import React from 'react';

const TextInput = (props) => {
  const username = props.record ? props.record.username : '';
  return <div>{username}</div>;
};

export default TextInput;
